"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("../utils/types");
var prosemirror_state_1 = require("prosemirror-state");
var tools_1 = require("../utils/tools");
var parse_1 = require("@syl-editor/core-utilities/dist/lib/libs/parse");
var DEFAULT_WIDTH = 375;
var PLUGIN_NAME = 'image';
var IMAGE_SIZE = {};
var getImageSize = function (src) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        if (IMAGE_SIZE[src])
            return [2 /*return*/, IMAGE_SIZE[src]];
        IMAGE_SIZE[src] = new Promise(function (resolve) {
            var img = new window.Image();
            img.src = src;
            img.onload = function (e) {
                IMAGE_SIZE[src] = { naturalWidth: img.naturalWidth, naturalHeight: img.naturalHeight };
                resolve(IMAGE_SIZE[src]);
            };
            img.onerror = function () {
                // @ts-ignore
                IMAGE_SIZE[src] = null;
                resolve({ naturalWidth: 0, naturalHeight: 0 });
            };
        });
        return [2 /*return*/, IMAGE_SIZE[src]];
    });
}); };
// 获取文件列表里面的图片文件
var getImageFileList = function (files) {
    return Array.prototype.slice.call(files || '').filter(function (file) { return file.type.includes('image'); });
};
// 获取选择框选择的图片文件
var getInputImageFiles = function (event) {
    if (!event.target.files)
        return [];
    return getImageFileList(event.target.files);
};
// 根据原图宽高比计算出高度或者宽度的值
var getSizeByRatio = function (ratio, // 宽高比
width, height) {
    var res = {};
    if (!width && !height) {
        res.width = DEFAULT_WIDTH;
        res.height = tools_1.getFixSize(DEFAULT_WIDTH / ratio);
    }
    else if (!width && height) {
        res.width = tools_1.getFixSize(height * ratio);
    }
    else if (width) {
        res.height = tools_1.getFixSize(width / ratio);
    }
    return res;
};
// 处理上传完成后返回新的宽高，保持宽高比
var constructAttrs = function (oAttrs, nAttrs) {
    var attrs = {};
    if ((!nAttrs.width || !nAttrs.height) && oAttrs.height && oAttrs.width) {
        var ratio = oAttrs.width / oAttrs.height;
        attrs = getSizeByRatio(ratio, nAttrs.width, nAttrs.height);
    }
    return __assign(__assign(__assign({}, oAttrs), nAttrs), attrs);
};
// 处理粘贴缺少宽高，获取原图宽高比然后计算
var correctSize = function (props, doUpdate) {
    if (doUpdate === void 0) { doUpdate = true; }
    var _a = props.attrs, src = _a.src, width = _a.width, height = _a.height;
    if (width && height)
        return { width: width, height: height };
    return new Promise(function (resolve) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, naturalWidth, naturalHeight, ratio, res;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, getImageSize(src)];
                case 1:
                    _a = _b.sent(), naturalWidth = _a.naturalWidth, naturalHeight = _a.naturalHeight;
                    if (!naturalWidth || !naturalHeight)
                        resolve({});
                    else {
                        ratio = naturalWidth / naturalHeight;
                        res = getSizeByRatio(ratio, width, height);
                        doUpdate && props.adapter.update(res, props.getPos());
                        resolve(res);
                    }
                    return [2 /*return*/];
            }
        });
    }); });
};
// 根据配置检查当前图片的url是否符合要求，不符合需触发上传操作
var checkDomain = function (src) {
    return (Image.ImageService.imageConfiguration.allowDomains || [/./]).some(function (domain) {
        if (typeof domain === 'string')
            return src.includes(domain);
        return domain.test(src);
    });
};
// 文件展示的时候会转成ObjectURL，这里反向，用于上传
var transformBlobFromObjectURL = function (url) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, new Promise(function (resolve, reject) {
                    var xhr = new XMLHttpRequest();
                    xhr.open('GET', url);
                    xhr.responseType = 'blob';
                    xhr.onload = function (e) {
                        if (xhr.status === 200)
                            resolve(xhr.response);
                        else
                            reject();
                    };
                    xhr.onerror = function (e) { return reject(e); };
                    xhr.send();
                })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
// 执行上传图片操作
var uploadImg = function (adapter, src, fileName) { return __awaiter(void 0, void 0, void 0, function () {
    var res, config, uploadRes, err_1, onUploadError, deleteFailedUpload, nodeInfos;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                res = src;
                if (!types_1.isObjectURL(src)) return [3 /*break*/, 2];
                return [4 /*yield*/, transformBlobFromObjectURL(src)];
            case 1:
                res = _b.sent();
                _b.label = 2;
            case 2:
                config = Image.ImageService.imageConfiguration;
                if (typeof res !== 'string' && config.uploadType === 'file') {
                    res = new File([res], fileName, { type: (_a = res) === null || _a === void 0 ? void 0 : _a.type });
                }
                _b.label = 3;
            case 3:
                _b.trys.push([3, 5, , 6]);
                return [4 /*yield*/, config.uploader(res, {
                        src: src
                    })];
            case 4:
                uploadRes = _b.sent();
                return [2 /*return*/, typeof uploadRes === 'string' ? { src: uploadRes || src } : uploadRes];
            case 5:
                err_1 = _b.sent();
                onUploadError = config.onUploadError, deleteFailedUpload = config.deleteFailedUpload;
                if (deleteFailedUpload) {
                    nodeInfos = adapter.getExistNodes(PLUGIN_NAME);
                    nodeInfos.some(function (_a) {
                        var node = _a.node, pos = _a.pos;
                        if (node.attrs.src === src) {
                            adapter.deleteCard(pos);
                            return true;
                        }
                    });
                }
                if (onUploadError)
                    onUploadError(res, err_1);
                else
                    throw err_1;
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}); };
// 插入到编辑器中
var insertImageInEditor = function (adapter, dataInfos, pos) {
    var insertNodes = { type: 'doc', content: [] };
    var config = Image.ImageService.imageConfiguration;
    var _pos = pos;
    dataInfos.forEach(function (_a) {
        var image = _a.image, attrs = _a.attrs;
        if (!image || !attrs)
            return;
        var imageAttrs = __assign({ width: config.uploadMaxWidth ? Math.min(image.naturalWidth, config.uploadMaxWidth) : image.naturalWidth, name: image.getAttribute('name') || '', alt: '', align: 'center' }, attrs);
        if (config.insertUploadingNode)
            config.insertUploadingNode(adapter, imageAttrs, _pos++);
        else
            insertNodes.content.push({ type: PLUGIN_NAME, attrs: imageAttrs });
    });
    if (insertNodes.content.length)
        adapter.insert(insertNodes, pos);
};
// 拿到图片文件，判断是否预先上传
var insertImageWithFiles = function (adapter, files) { return __awaiter(void 0, void 0, void 0, function () {
    var config, results;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                config = Image.ImageService.imageConfiguration;
                return [4 /*yield*/, Promise.all(files.map(function (f) {
                        return new Promise(function (resolve) {
                            var url = window.URL.createObjectURL(f);
                            var attrs = { src: url };
                            var image = document.createElement('img');
                            image.onload = function () { return __awaiter(void 0, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (!config.uploadBeforeInsert) return [3 /*break*/, 2];
                                            return [4 /*yield*/, uploadImg(adapter, url, f.name)];
                                        case 1:
                                            attrs = _a.sent();
                                            if (!attrs)
                                                resolve({});
                                            _a.label = 2;
                                        case 2:
                                            resolve({ attrs: attrs, image: image });
                                            return [2 /*return*/];
                                    }
                                });
                            }); };
                            image.onerror = function (e) { return __awaiter(void 0, void 0, void 0, function () {
                                var onUploadError;
                                return __generator(this, function (_a) {
                                    onUploadError = config.onUploadError;
                                    onUploadError && onUploadError(f, e);
                                    resolve({});
                                    return [2 /*return*/];
                                });
                            }); };
                            image.src = attrs.src;
                            image.setAttribute('name', f.name);
                        });
                    }))];
            case 1:
                results = _a.sent();
                insertImageInEditor(adapter, results, adapter.view.state.selection.from);
                return [2 /*return*/];
        }
    });
}); };
// 解析编辑器产生的图片的DOM数据
var parseSylDOM = function (dom, fixClass, captionClass) {
    var image = dom.querySelector('img') || null;
    var caption = dom.querySelector(captionClass);
    var fixer = dom.querySelector(fixClass);
    var alt = (caption && (caption.innerText || caption.value)) || '';
    var src = (image && image.src) || '';
    var width = image.width;
    var height = image.height;
    var name = image.getAttribute('name') || '';
    var align = 'center';
    if (fixer) {
        if (fixer.classList.contains('left'))
            align = 'left';
        else if (fixer.classList.contains('right'))
            align = 'right';
    }
    var attrs = { src: src, alt: alt, width: width, height: height, align: align, name: name };
    tools_1.getFromDOMByConfig(Image.ImageService.imageConfiguration.addAttributes, dom, attrs);
    return attrs;
};
// TODO 不要使用namespace，这种配置方式不支持多个实例
var Image;
(function (Image) {
    Image.MAX_WIDTH = window.innerWidth - 40;
    Image.MAX_TITLE_SIZE = 20;
    var ImageService;
    (function (ImageService) {
        var _this = this;
        ImageService.imageConfiguration = {
            uploader: function () { return Promise.resolve(''); },
            uploadBeforeInsert: false,
            placeholder: '',
            uploadType: 'blob',
            listenDrop: true,
            listenPaste: true,
            maxLength: 20,
            uploadMaxWidth: DEFAULT_WIDTH
        };
        function setImageConfiguration(userConfig) {
            if (typeof userConfig.uploader !== 'function') {
                throw new TypeError('Type of uploader must be function!');
            }
            Object.assign(ImageService.imageConfiguration, userConfig);
            if (userConfig.addAttributes)
                tools_1.addAttrsByConfig(userConfig.addAttributes, Image.configuration.attrs);
        }
        ImageService.setImageConfiguration = setImageConfiguration;
        function ImageFileInputFactory(adapter) {
            var input = tools_1.createFileInput({
                multiple: true,
                accept: ImageService.imageConfiguration.accept || 'image/*',
                onChange: function (e) {
                    var files = getInputImageFiles(e);
                    insertImageWithFiles(adapter, files);
                },
                getContainer: function () { return adapter.root; }
            });
            return input;
        }
        ImageService.ImageFileInputFactory = ImageFileInputFactory;
        ImageService.updateImageUrl = function (props, dispatch) { return __awaiter(_this, void 0, void 0, function () {
            var _a, src, name, state, attrs, imgSize, imageAttrs, err_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        Image.MAX_WIDTH = props.adapter.view.dom.scrollWidth - 40;
                        _a = props.attrs, src = _a.src, name = _a.name;
                        if (props.state === undefined)
                            props.state = {};
                        state = props.state;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 4, , 5]);
                        // 上传状态，同一时刻同一实例最多只允许一个上传请求
                        if (state.uploading || (!types_1.isObjectURL(src) && checkDomain(src))) {
                            correctSize(props);
                            return [2 /*return*/];
                        }
                        state.uploading = true;
                        return [4 /*yield*/, uploadImg(props.adapter, src, name)];
                    case 2:
                        attrs = _b.sent();
                        state.uploading = false;
                        if (!attrs)
                            return [2 /*return*/];
                        return [4 /*yield*/, correctSize(__assign(__assign({}, props), { attrs: __assign(__assign({}, props.attrs), attrs) }), false)];
                    case 3:
                        imgSize = _b.sent();
                        imageAttrs = constructAttrs(__assign(__assign({}, props.attrs), imgSize), attrs);
                        if (ImageService.imageConfiguration.replaceUploadingNode) {
                            ImageService.imageConfiguration.replaceUploadingNode(props.adapter, imageAttrs);
                        }
                        else if (dispatch && src !== attrs.src) {
                            dispatch(imageAttrs);
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        err_2 = _b.sent();
                        state.uploading = false;
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
    })(ImageService = Image.ImageService || (Image.ImageService = {}));
    Image.configuration = {
        name: PLUGIN_NAME,
        tagName: function () { return 'img'; },
        traceSelection: false,
        parseDOM: [
            {
                tag: 'div.syl-image-wrapper',
                getAttrs: function (dom) { return parseSylDOM(dom, '.syl-image-fixer', '.syl-image-caption'); }
            },
            {
                tag: '.sylimage-wrapper',
                getAttrs: function (dom) { return parseSylDOM(dom, '.sylimage-fixer', '.sylimage-caption'); }
            },
            {
                tag: 'img',
                getAttrs: function (dom) {
                    if (!dom.src)
                        return false;
                    var attrWidth = dom.getAttribute('width');
                    var attrHeight = dom.getAttribute('height');
                    var width = parse_1.getPx(dom.style.width || (attrWidth && attrWidth + "px") || '', 16);
                    var height = parse_1.getPx(dom.style.height || (attrHeight && attrHeight + "px") || '', 16);
                    if (!width || isNaN(width))
                        width = 0;
                    if (!height || isNaN(height))
                        height = 0;
                    if (width > Image.MAX_WIDTH) {
                        if (height)
                            height = height / (width / Image.MAX_WIDTH);
                        width = Image.MAX_WIDTH;
                    }
                    var formattedAttrs = {
                        src: dom.getAttribute('src') || '',
                        alt: dom.getAttribute('alt') || '',
                        name: dom.getAttribute('name') || '',
                        align: dom.getAttribute('align') || 'center',
                        width: width,
                        height: height
                    };
                    tools_1.getFromDOMByConfig(Image.ImageService.imageConfiguration.addAttributes, dom, formattedAttrs);
                    return formattedAttrs;
                }
            }
        ],
        toDOM: function (node) {
            var attrs = __assign({}, node.attrs);
            tools_1.setDOMAttrByConfig(Image.ImageService.imageConfiguration.addAttributes, node, attrs);
            return ['img', attrs];
        },
        attrs: {
            src: {
                default: ''
            },
            alt: {
                default: ''
            },
            name: {
                default: ''
            },
            width: {
                default: 0
            },
            height: {
                default: 0
            },
            align: {
                default: 'center'
            }
        },
        props: {
            handleClickOn: function (editor, view, pos, node, nodePos, event) {
                if (node.type.name === PLUGIN_NAME) {
                    var caption = event.target.closest('.syl-image-caption');
                    if (caption) {
                        var input = caption.querySelector('input');
                        if (input)
                            input.focus();
                        var newTextSelection = prosemirror_state_1.TextSelection.create(view.state.doc, nodePos);
                        view.dispatch(view.state.tr.setSelection(newTextSelection));
                        return true;
                    }
                    // 当当前选中的是图片，但是系统却表现为光标时，修正selection
                    // 真正选中为图片是type是Range
                    var state = view.state, dispatch = view.dispatch;
                    var curSelection = window.getSelection();
                    if (curSelection && curSelection.type === 'Caret') {
                        var truePos = view.posAtCoords({
                            left: event.screenX,
                            top: event.screenY
                        });
                        if (truePos) {
                            dispatch(state.tr.setSelection(prosemirror_state_1.TextSelection.create(view.state.doc, truePos.pos)));
                            return true;
                        }
                    }
                    return false;
                }
                return false;
            },
            handlePaste: function (editor, view, e) {
                var event = e;
                if (!ImageService.imageConfiguration.listenPaste || !event.clipboardData) {
                    return false;
                }
                var files = getImageFileList(event.clipboardData.files);
                if (!files.length || event.clipboardData.getData('text/html')) {
                    return false;
                }
                insertImageWithFiles(editor, files);
                return true;
            },
            handleDOMEvents: {
                drop: function (editor, view, e) {
                    var event = e;
                    if (view.dragging || !ImageService.imageConfiguration.listenDrop || !event.dataTransfer) {
                        return false;
                    }
                    var files = getImageFileList(event.dataTransfer.files);
                    if (!files.length)
                        return false;
                    insertImageWithFiles(editor, files);
                    e.preventDefault();
                    return true;
                }
            }
        }
    };
})(Image = exports.Image || (exports.Image = {}));
//# sourceMappingURL=image.js.map